import {
  model,
  Model,
  prop,
  modelAction,
  ModelCreationData,
} from 'mobx-keystone';

@model('bpEwells/Site')
export default class Site extends Model({
  id: prop<number>(),
  name: prop<string>(''),
  isActive: prop<boolean>(),

  // foreign key ids
  performanceUnit: prop<number>(),
  siteType: prop<number>(),
}) {
  @modelAction
  update(data: ModelCreationData<Site>) {
    Object.assign(this, data);
  }
}
